import React, { Component } from 'react';
import $ from 'jquery';

import CourseLayout from './../courselayout';


import { adminDashboard } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { Chart, registerables } from 'chart.js';


const doughnutPieOptions = {
          responsive: true,
          animation: {
            animateScale: true,
            animateRotate: true
          }
        };    

const optionsN = {
    scales: {
        yAxes: [{
            ticks: {
                beginAtZero: true
            }
        }],

    }
}

class courseDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
          auth_data: JSON.parse(localStorage.getItem("user_data")),
          school_data: []
        };
    }

    componentDidMount() {

        let req = {
            url: 'school_data'
        };

        adminDashboard(JSON.stringify(req)).then(response => {
            if (response.status === 1) {
                this.setSchoolChart(response.result);
            }
        });
      
        this.setState({user_name:this.state.auth_data.user_name, role:this.state.auth_data.role});   


        req.url = 'like_follow_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setLike(response.result);
            }
        });


        req.url = 'vistors_chart';
        adminDashboard(JSON.stringify(req)).then(response => {

            if (response.status === 1) {
                this.setVisitors(response.result);
            }
        });


    }

    setVisitors = (data) => {

        var ctx = document.getElementById('barChartVisitors');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }    

    setLike = (data) => {

        var ctx = document.getElementById('barChartLikeFollows');
        var myChart = new Chart(ctx, {
            type: 'bar',
            data: data,
            options: optionsN
        });
    }

    setAfterschoolChart = (data) => {

        var ctx = document.getElementById('afterschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }    

    setTuitionChart = (data) => {

        var ctx = document.getElementById('tuitionChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setSchoolChart = (data) => {

        var ctx = document.getElementById('schoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setPreschoolChart = (data) => {

        var ctx = document.getElementById('preschoolChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    } 


    setcampChart = (data) => {

        var ctx = document.getElementById('campChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setcommunityChart = (data) => {

        var ctx = document.getElementById('communityChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }

    setbirthdayChart = (data) => {

        var ctx = document.getElementById('birthdayChart');
        var myChart = new Chart(ctx, {
            type: 'doughnut',
            data: data,
            options: doughnutPieOptions
        });

    }        


    render() {

        return (
          <React.Fragment>
          <CourseLayout>
                    
            <div class="row  mt-3">
           

              <div class="col-xl-6 d-flex grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-wrap justify-content-between">
                      
                           <strong> Hi, Welcome.  you can add your courses here.</strong>

                    </div>
                     
                  </div>
                </div>
              </div>

            </div>

                </CourseLayout>
            </React.Fragment>
        )
    }
}


export default courseDashboard;


// WEBPACK FOOTER //
// ./src/components/bewise/courses/dashboard.jsx